<div class="footer text-white pt-4" style="background-color: #004080">
  <div class="container-fluid p-0 m-0">
    <div class="row border-bottom mb-3">
      <div class="col-md-3 col-sm-12 text-center mt-4">
        <img
          src="/assets/images/gaif-logo.png"
          alt="GAIF Logo"
          style="min-width: 150px"
        />
        <h2 class="mt-3">
          {{ "footer.generalArab" | translate }} <br />{{
            "footer.insuranceFederation" | translate
          }}
        </h2>
      </div>
      <div class="col-md-2 col-sm-12 mt-3 mb-3">
        <h3>{{ "footer.quickLinks" | translate }}</h3>
        <div class="row" *ngIf="quickLinks.length > 0">
          <div class="col-12 mt-3 p-0" *ngFor="let link of quickLinks">
            <img
              [src]="'/assets/svg/' + link.imgPath"
              class="arrow"
              [ngClass]="{
                'arrow-ar': isArabic
              }"
            />
            <a
              [routerLink]="[link.routeTo]"
              class="text-white text-decoration-none"
              >{{ link.name | translate }}</a
            >
          </div>
        </div>
      </div>

      <div class="col-md-2 col-sm-12 mt-3 mb-3">
        <div class="row pt-5 arab-ins-links">
          <div class="col-12 pt-3" *ngFor="let link of arabInsLinks">
            <img
              class="d-inline-block mx-2"
              [src]="'/assets/svg/' + link.imgPath"
            />
            <a
              [routerLink]="[link.routeTo]"
              class="text-white text-decoration-none"
              >{{ link.name | translate }}</a
            >
          </div>
        </div>
      </div>

      <div class="col-md-5 col-sm-12 mt-3 mb-3 contact-us">
        <h3>{{ "footer.contactUs" | translate }}</h3>
        <div class="row pt-3" *ngFor="let link of contactUsLinks">
          <div class="col-12 col-lg-3 p-0" [ngClass]="{'class': true}">
            <img
              class="d-inline-block mx-2" 
              [src]="'/assets/svg/' + link.imgPath"
             
            />
           
            {{ link.name | translate }}
          </div>
          <div
            class="col-12 col-lg-6 px-0"
            [dir]="link.name == 'footer.phone' ||link.name == 'footer.fax' || link.name == 'footer.email' ?'ltr':'ltr'"
            [innerHTML]="isArabic ? link.descriptionAr : link.descriptionEn"
          ></div>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col text-center mt-2">
        <p [innerHTML]="'footer.copyrights' | translate">
       
        </p>
      </div>
    </div>
  </div>
</div>
